import { render, staticRenderFns } from "./CoozzyListGroup.vue?vue&type=template&id=1e316771&scoped=true"
import script from "./CoozzyListGroup.vue?vue&type=script&lang=js"
export * from "./CoozzyListGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e316771",
  null
  
)

export default component.exports